import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-git1-icon',
  templateUrl: './code-git1.component.html'
})
export class CodeGit1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
